import { Injectable, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from './models/user';
import { Rucher } from './models/rucher';
import { Nomenclature } from './models/nomenclature';
import { Intervention } from './models/intervention';
import { Ruche } from './models/ruche';
import { Actu } from './models/actu';
import { Image } from './models/image';

@Injectable()
export class AppService {
    private data;
    public nomenclatures: Nomenclature[] = [];
    public ruchers: Rucher[] = [];
    public modal: TemplateRef<any>;
    public errorModal: TemplateRef<any>;
    public confirmModal: TemplateRef<any>;
    public writeIntervetionModal: TemplateRef<any>;
    public userCourant: User = new User();
    public ruches: Ruche[] = [];
    public listeInterventions: Intervention[];
    public actu: Actu = new Actu();
    public photos: Image[] = [];

    constructor(
            private http: HttpClient) { }

    private sagerucherUrl = './rest/restapi.php?rquest=';
    // private sagerucherUrl = './sagerucher-server/rest/restapi.php?rquest=';
// private sagerucherUrl = 'http://localhost:4444/sagerucher-server/rest/restapi.php?rquest=';

    getActu(): Observable<Actu> {
        this.data = this.http.get<Actu>(this.sagerucherUrl + 'getactu');
        return this.data;
    }

    getTexteActuHTML(): string {
        return this.actu.texte.replace("\n", "<br>");
    }

    getRuchers(): Observable<Rucher[]> {
        this.data = this.http.get<Rucher[]>(this.sagerucherUrl + 'getruchers');
        return this.data;
    }

    getListeRuchersAvecDiscrimination(ruchersAEnlever: Rucher[]): Rucher[] {
        let ruchersDiscrimines = this.ruchers.slice(0);
        for (let rucherAEnlever of ruchersAEnlever) {
            ruchersDiscrimines.splice(ruchersDiscrimines.findIndex(rucher=>rucher.id_rucher===rucherAEnlever.id_rucher), 1);
        }
        return ruchersDiscrimines;
    }

    getRucher(id: string): Rucher {
        return this.ruchers.find(rucher => rucher.id_rucher === id);
    }

    getUser(login: string): Observable<User> {
        this.data = this.http.get<User>(this.sagerucherUrl + 'getuser&login=' + login);
        return this.data;
    }

    getInterventions(id_rucher: string): Observable<Intervention[]> {
        this.data = this.http.get<Intervention[]>(this.sagerucherUrl + 'getinterventions&id_rucher=' + id_rucher);
        return this.data;
    }

    getIntervention(id_inter_rucher: string): Observable<Intervention> {
        this.data = this.http.get<Intervention>(this.sagerucherUrl + 'getintervention&id_inter_rucher=' + id_inter_rucher);
        return this.data;
    }

    addIntervention(intervention: Intervention): Observable<Intervention[]> {
        return this.http.post<Intervention[]>(this.sagerucherUrl + 'addIntervention', JSON.stringify(intervention));
    }

    updateIntervention(intervention: Intervention): Observable<Intervention[]> {
        return this.http.post<Intervention[]>(this.sagerucherUrl + 'updateIntervention', JSON.stringify(intervention));
    }

    getRuches(): Observable<Ruche[]> {
        this.data = this.http.get<Ruche[]>(this.sagerucherUrl + 'getRuches');
        return this.data;
    }

    getRuche(id: string): Ruche {
        let rucheCour = this.ruches.find(ruche => ruche.id_ruche === id);
        return rucheCour;
    }

    getListeRuchesAvecDiscrimination(ruchesTotales:Ruche[], ruchesAEnlever: Ruche[]): Ruche[] {
        let ruchesDiscriminees = ruchesTotales.slice(0);
        for (let rucheAEnlever of ruchesAEnlever) {
            ruchesDiscriminees.splice(ruchesDiscriminees.findIndex(ruche=>ruche.id_ruche===rucheAEnlever.id_ruche), 1);
        }
        return ruchesDiscriminees;
    }
    
    /*****************************************************************************/
    /********************************NOMENCLATURES********************************/
    /*****************************************************************************/
    chargerNomenclatures(): Observable<Nomenclature[]> {
        this.data = this.http.get<Nomenclature[]>(this.sagerucherUrl + 'chargernomenclatures');
        return this.data;
    }

    getNomenclatureByTypeAndCode(type: string, code: string): Nomenclature {
        let nomenclature: Nomenclature = new Nomenclature();
        nomenclature.libelle = 'Nomenclature inconnue'

        let filter = this.nomenclatures.filter(nom => nom.type === type && nom.code === code);

        if (filter.length !== 0) {
            nomenclature = filter[0];
        }

        return nomenclature;
    }

    getNomenclatureById(id: string): Nomenclature {
        let nomenclature: Nomenclature = new Nomenclature();

        let filter = this.nomenclatures.filter(nom => nom.id_nom === id);

        if (filter.length !== 0) {
            nomenclature = filter[0];
        }

        return nomenclature;
    }

    getNomenclaturesByType(type: string): Nomenclature[] {
        return this.nomenclatures.filter(nom => nom.type === type);
    }

    getLibelleNomenclaturesByType(type: string): String[] {
        let libelles: String[] = [];
        for (let nom of this.nomenclatures.filter(nom => nom.type === type)) {
            libelles.push(nom.libelle);
        }
        return libelles;
    }

    getPhotos(): Observable<Image[]> {
        this.data = this.http.get<Image[]>(this.sagerucherUrl + 'getPhotos');
        return this.data;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.service.ts